import axios from "axios";

import { URLS } from "globalConstants";
import { axiosWithAuth, encodeObjToURI } from "helpers";

export const fusionAuthService = {
	getFusionAuthUsers,
	getRefreshedTokens,
	getTokens,
	goToAuthorize,
	goToLogout,
	linkUser,
	unlinkUser,
};

const API_URL = process.env.REACT_APP_API_URL;
const REACT_APP_FA_CLIENT_ID = process.env.REACT_APP_FA_CLIENT_ID;
const REACT_APP_AUTH_URI = `${window.location.origin}${URLS.login}`;

const getRedirectURI = (redirectToPath: string | null = "") => {
	return `${REACT_APP_AUTH_URI}${
		redirectToPath ? "?path=" + redirectToPath : ""
	}`;
};

function goToAuthorize(redirectToPath: string = "") {
	window.location.replace(
		`${API_URL}/api/bff/oauth2/authorize?client_id=${REACT_APP_FA_CLIENT_ID}&redirect_uri=${getRedirectURI(
			redirectToPath,
		)}`,
	);
}

function getTokens(authCode, redirectToPath: string | null = "") {
	const options = {
		method: "POST" as const,
		data: encodeObjToURI({
			client_id: REACT_APP_FA_CLIENT_ID,
			code: authCode,
			redirect_uri: `${getRedirectURI(redirectToPath)}`,
		}),
		headers: {
			"Content-Type": "application/x-www-form-urlencoded",
		},
		url: `${API_URL}/api/bff/oauth2/token`,
	};

	return axios(options);
}

function getRefreshedTokens(refreshToken) {
	const options = {
		method: "POST" as const,
		data: encodeObjToURI({
			client_id: REACT_APP_FA_CLIENT_ID,
			refresh_token: refreshToken,
		}),
		headers: {
			"Content-Type": "application/x-www-form-urlencoded",
		},
		url: `${API_URL}/api/bff/oauth2/token/refresh`,
	};

	return axios(options);
}

function goToLogout() {
	window.location.replace(
		`${API_URL}/api/bff/oauth2/logout?client_id=${REACT_APP_FA_CLIENT_ID}`,
	);
}

function getFusionAuthUsers({ userId }: { userId: string }) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/users/${userId}/search_in_fusion_auth`,
	};

	return axiosWithAuth(options);
}

function linkUser({
	userId,
	fusionAuthUserId,
}: {
	userId: string;
	fusionAuthUserId: string;
}) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/users/${userId}/link_with_fusion_auth`,
		data: { fusion_auth_user_id: fusionAuthUserId },
	};

	return axiosWithAuth(options);
}

function unlinkUser({ userId }: { userId: string }) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/users/${userId}/unlink_with_fusion_auth`,
	};

	return axiosWithAuth(options);
}
